/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { WidgetLoader } from 'datastake-daf/dist/components';
import { RotateLeftOutlined, RotateRightOutlined } from '@ant-design/icons';
import ReactFlow, { ControlButton, Controls, ReactFlowProvider } from 'react-flow-renderer';
import Style from './style';
import { useSupplyChainMap } from './hook';

const SupplyChainMap = ({
  data = {},
  sources = [],
  defaultSources = [],
  trade = [],
  callback = () => { },
  title = '',
  type = 'default',
  loadingComponent = false,
  setReports = null,
  defaultActive = null,
  disabledIds,
  empty = false,
  openSettings = () => { },
  height = '600px',
  projectData = {},
  setPopoverVisible = () => {},
}) => {
  const { t } = useTranslation();

  const {
    elements,
    getHeader,
    margin,
    loader,
    isLoading,
    onElementsRemove,
    onConnect,
    onLoad,
    flow,
    setFlow,
  } = useSupplyChainMap({
    setPopoverVisible,
    data,
    sources,
    defaultSources,
    trade,
    callback,
    title,
    type,
    setReports,
    defaultActive,
    disabledIds,
    projectData,
    t,
  });

  if (empty) {
    return (
      <Style>
        <div className='empty-state'>
          <div className='message'>
            <img
              src='/assets/images/dashboard/project/illustration.png'
              alt='illustration'
            />
            <h2>
              {t('Manage supply chain actors and associated mine sites')}
            </h2>
            <p>
              {t('You can manage your material flow in dashboard settings')}
            </p>
            <Button
              type='primary'
              onClick={openSettings}
            >
              {t('Data Settings')}
              <svg className='ml-2' width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.833313 9.16634L9.16665 0.833008M9.16665 0.833008H0.833313M9.16665 0.833008V9.16634" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Button>
          </div>
        </div>
      </Style>
    );
  }

  return (
    <>
      {getHeader()}
      <div
        className="row between mb-20 scp-map"
        style={{
          margin,
          height,
          width: '100%',
          background: '#EDF6FE',
          overflow: 'hidden',
        }}>
        <Style>
          {isLoading && loader}
          <div className="cont">
            {loadingComponent && <WidgetLoader background="rgba(255, 255, 255, 0.7)" />}
            <ReactFlowProvider>
              <ReactFlow
                elements={elements.length ? elements : []}
                onElementsRemove={onElementsRemove}
                onConnect={onConnect}
                onLoad={onLoad}
                selectNodesOnDrag={false}
                draggable={false}
                nodesDraggable={false}
                nodesConnectable={false}
              >
                <Controls>
                  <ControlButton
                    onClick={() => flow === 'LR' ? setFlow('TB') : setFlow('LR')}
                  >
                    {flow === 'TB' ? <RotateLeftOutlined /> : <RotateRightOutlined />}
                  </ControlButton>
                </Controls>
              </ReactFlow>
            </ReactFlowProvider>
          </div>

        </Style>
      </div>
    </>
  );
};

export default SupplyChainMap;
